import React from 'react';

type InputProps = {
  changeHistoryId: number;
  newValue: Array<number>;
  oldValue: Array<number>;
  associationLabel: string;
  getAssociationNameById: (id: number) => string;
};

export const EmployeeHistoryAssociationDetail = ({
  changeHistoryId,
  newValue,
  oldValue,
  associationLabel,
  getAssociationNameById,
}: InputProps) => {
  if (!newValue.length && !oldValue.length) {
    return null;
  }

  const sortedArrayDiff = (arrayA: Array<number>, arrayB: Array<number>) => {
    const changedItems = arrayA.filter((id) => !arrayB.includes(id));
    return changedItems
      .map((employeeId) => getAssociationNameById(employeeId))
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b));
  };

  const associationChanges = {
    addedNames: sortedArrayDiff(newValue, oldValue),
    removedNames: sortedArrayDiff(oldValue, newValue),
  };

  if (!associationChanges.addedNames.length && !associationChanges.removedNames.length) {
    return null;
  }

  return (
    <div className="typo-subtitle">
      {associationChanges.addedNames.length ? (
        <div>
          <div className="typo-bold">{`Added ${associationLabel}${
            associationChanges.addedNames.length > 1 ? 's' : ''
          }:`}</div>
          <ul>
            {associationChanges.addedNames.map(
              (addedName) =>
                addedName && (
                  <li key={`${changeHistoryId}-added-${associationLabel}-${addedName}`}>
                    {addedName}
                  </li>
                ),
            )}
          </ul>
        </div>
      ) : null}
      {associationChanges.removedNames.length ? (
        <div>
          <div className="typo-bold">{`Removed ${associationLabel}${
            associationChanges.removedNames.length > 1 ? 's' : ''
          }:`}</div>
          <ul>
            {associationChanges.removedNames.map(
              (removedName) =>
                removedName && (
                  <li key={`${changeHistoryId}-removed-${associationLabel}-${removedName}`}>
                    {removedName}
                  </li>
                ),
            )}
          </ul>
        </div>
      ) : null}
    </div>
  );
};
